import Reveal from "@/components/base/Reveal";

const STEPS = [
  {
    num: "01",
    title: "Conte o problema",
    description: "Envie as informações do equipamento.",
  },
  {
    num: "02",
    title: "Avaliação",
    description: "A equipe analisa a necessidade.",
  },
  {
    num: "03",
    title: "Solução e orçamento",
    description: "O caminho recomendado é apresentado.",
  },
  {
    num: "04",
    title: "Execução",
    description: "Após aprovação, o serviço segue o processo técnico aplicável.",
  },
];

export default function Process() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <h2 className="text-center font-heading text-3xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
            Simples para você. Técnico onde precisa ser.
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, i) => (
            <Reveal key={step.num} delay={i * 80}>
              <div className="relative h-full rounded-lg border border-background-200 bg-background-50 p-6">
                <span className="font-heading text-4xl font-extrabold text-primary-200">
                  {step.num}
                </span>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {step.description}
                </p>
                {i < STEPS.length - 1 && (
                  <i
                    className="ri-arrow-right-line absolute -right-3 top-1/2 hidden -translate-y-1/2 text-xl text-primary-400 lg:block"
                    aria-hidden="true"
                  />
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}